export default __webpack_public_path__ + "static/media/ILUSTRACIONES_04.0e065180.png";